import type { ReactNode } from 'react';

type Tipo = 'erro' | 'ok' | 'alerta' | 'info';

const ESTILO: Record<Tipo, string> = {
  erro: 'border-erro/50 bg-erro/10 text-erro',
  ok: 'border-ok/50 bg-ok/10 text-ok',
  alerta: 'border-alerta/50 bg-alerta/10 text-alerta',
  info: 'border-edge bg-panel text-mute',
};

export default function Aviso({
  tipo = 'info', children,
}: { tipo?: Tipo; children: ReactNode }) {
  if (!children) return null;
  return (
    <div
      className={`border px-4 py-3 text-sm ${ESTILO[tipo]}`}
      role={tipo === 'erro' ? 'alert' : 'status'}
    >
      {children}
    </div>
  );
}
